/*
  /login — deep-linkable page wrapper around AuthForm.
  Redirects to / once auth completes. If already signed-in, bounces to /.
*/
import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import AuthForm from "../components/AuthForm";
import { useAuth } from "../contexts/AuthContext";

export default function LoginPage() {
  const { user, loading } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && user) nav("/", { replace: true });
  }, [user, loading, nav]);

  return (
    <div className="max-w-md mx-auto w-full py-8" data-testid="login-page">
      <div className="mb-6">
        <h1 className="font-display tracking-tighter text-3xl mb-1" style={{ color: "var(--primary-ink)" }}>
          Welcome back
        </h1>
        <p className="text-sm" style={{ color: "var(--text-muted)" }}>
          Sign in to sync your VeriHandi data across devices.
        </p>
      </div>
      <div className="card-tactile rounded-2xl p-5">
        <AuthForm initialMode="login" onDone={() => nav("/", { replace: true })} onForgot={() => nav("/forgot-password")} />
      </div>
      <p className="text-center text-xs mt-4" style={{ color: "var(--text-muted)" }}>
        <Link to="/" className="hover:underline">← Back to Hub</Link>
      </p>
    </div>
  );
}
